export default {
    METHODS: "Методы",
    DELETE: "Удалить",
    SEND_TO_GRAPH: "Отправить на граф"
};
